const INTEGER_MAX_VALUE = 2147483647;

export const validateNumber = (value?: number): boolean =>
  value !== undefined &&
  Number.isFinite(value) &&
  value >= 0 &&
  value <= INTEGER_MAX_VALUE;

export const validateDistance = (value?: number): boolean =>
  value !== undefined &&
  Number.isFinite(value) &&
  value >= 0 &&
  value * 1000 <= INTEGER_MAX_VALUE;
